// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__35Twi","signatureBlock":"Footer_signatureBlock__3rc4G","signature":"Footer_signature__3T4L4"};